import { Controller } from "@hotwired/stimulus"

// A recipe's figures, for the number of servings selected.
//
// THE FOODS TAB HAS DONE THIS SINCE IT WAS BUILT and the other two did not,
// so stepping a recipe from 1 to 2 left every figure beside it describing one
// serving. Four numbers quietly answering a different question than the
// control next to them.
//
// SIMPLER THAN food_calories, deliberately. A food's amount goes through a
// unit ("2 medium" is 236 g), so that controller carries the whole unit table.
// A recipe's servings are a plain multiplier: two servings is twice one.
// Sharing a controller would have meant one of them pretending to have units.
//
// The server stays the authority on what is SAVED. This previews a quantity
// that has not been submitted, so a rounding difference costs nothing.
export default class extends Controller {
  static targets = ["quantity", "kcal", "protein", "carbs", "fat"]
  static values = {
    kcal: Number,
    protein: Number,
    carbs: Number,
    fat: Number
  }

  connect() {
    this.render()
  }

  render() {
    const servings = parseFloat(this.quantityTarget?.value)
    const factor = Number.isFinite(servings) && servings > 0 ? servings : null

    this.paint("kcal", factor, this.kcalValue, true)
    this.paint("protein", factor, this.proteinValue)
    this.paint("carbs", factor, this.carbsValue)
    this.paint("fat", factor, this.fatValue)
  }

  paint(name, factor, perServing, kcal = false) {
    const capitalised = name[0].toUpperCase() + name.slice(1)
    if (!this[`has${capitalised}Target`]) return

    const text = factor === null || !Number.isFinite(perServing)
      ? "—"
      : (kcal ? String(Math.round(perServing * factor))
              : this.grams(perServing * factor))

    this.setFigure(this[`${name}Target`], text)
  }

  // MIRRORS ApplicationHelper#macro_grams — "0" for nothing, "<1" below a
  // gram, whole numbers above. Rounding plainly here would print "0" where
  // the server printed "<1", so a chip would change the moment you stepped
  // and change back on the next full render.
  grams(value) {
    if (value === 0) return "0"
    if (value < 1) return "<1"

    return String(Math.round(value))
  }

  // The number only, leaving the chip's label and unit alone: a chip reads
  // "P 1g" and this owns one of its three parts. Setting textContent would
  // replace all three and leave a bare number.
  setFigure(element, text) {
    const node = Array.from(element.childNodes)
      .find((child) => child.nodeType === Node.TEXT_NODE && child.textContent.trim())

    if (node) {
      node.textContent = text
    } else {
      element.textContent = text
    }
  }
}
